import React from 'react'
import RedEnvelopeDemoPage from './RedEnvelopeDemoPage'

/** หน้าเกมซองแดง prod — เรียก API จริง */
const RedEnvelopeGamePage: React.FC = () => <RedEnvelopeDemoPage variant="live" />

export default RedEnvelopeGamePage
